/* tslint:disable */
/* eslint-disable */
/**
 * Example API
 * API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SearchStops200ResponseResultsInner } from './SearchStops200ResponseResultsInner';
import {
    SearchStops200ResponseResultsInnerFromJSON,
    SearchStops200ResponseResultsInnerFromJSONTyped,
    SearchStops200ResponseResultsInnerToJSON,
    SearchStops200ResponseResultsInnerToJSONTyped,
} from './SearchStops200ResponseResultsInner';

/**
 * 
 * @export
 * @interface SearchStops200Response
 */
export interface SearchStops200Response {
    /**
     * 
     * @type {Array<SearchStops200ResponseResultsInner>}
     * @memberof SearchStops200Response
     */
    results?: Array<SearchStops200ResponseResultsInner>;
    /**
     * Total number of matches
     * @type {number}
     * @memberof SearchStops200Response
     */
    total?: number;
    /**
     * Current page number
     * @type {number}
     * @memberof SearchStops200Response
     */
    page?: number;
    /**
     * Results per page
     * @type {number}
     * @memberof SearchStops200Response
     */
    limit?: number;
    /**
     * Search query executed
     * @type {string}
     * @memberof SearchStops200Response
     */
    query?: string;
    /**
     * Search duration in milliseconds
     * @type {number}
     * @memberof SearchStops200Response
     */
    duration?: number;
}

/**
 * Check if a given object implements the SearchStops200Response interface.
 */
export function instanceOfSearchStops200Response(value: object): value is SearchStops200Response {
    return true;
}

export function SearchStops200ResponseFromJSON(json: any): SearchStops200Response {
    return SearchStops200ResponseFromJSONTyped(json, false);
}

export function SearchStops200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchStops200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'results': json['results'] == null ? undefined : ((json['results'] as Array<any>).map(SearchStops200ResponseResultsInnerFromJSON)),
        'total': json['total'] == null ? undefined : json['total'],
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'query': json['query'] == null ? undefined : json['query'],
        'duration': json['duration'] == null ? undefined : json['duration'],
    };
}

  export function SearchStops200ResponseToJSON(json: any): SearchStops200Response {
      return SearchStops200ResponseToJSONTyped(json, false);
  }

  export function SearchStops200ResponseToJSONTyped(value?: SearchStops200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': value['results'] == null ? undefined : ((value['results'] as Array<any>).map(SearchStops200ResponseResultsInnerToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'query': value['query'],
        'duration': value['duration'],
    };
}

